import { render, staticRenderFns } from "./ShareProofModal.vue?vue&type=template&id=7afa9fc4"
import script from "./ShareProofModal.vue?vue&type=script&lang=js"
export * from "./ShareProofModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports